export default {
  /*
  We have two type of filter bar data:
  - preselected. this is where a filter value was supplied in the URL.
  - lastUsed. this is where we remember the last filter bar config used.
   */
  preselected: {},
  lastUsed: {},
};
